// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Uwnm","content":"styles_content__24nn2","tableWrap":"styles_tableWrap__13Sih"};